import { MailWarning, FileStack, CalendarClock } from "lucide-react";

const ITEMS = [
    {
        icon: MailWarning,
        title: "Immer dieselben Kundenanfragen",
        text: "„Haben Sie meine Mail bekommen?”, „Wie weit ist mein Auftrag?”, „Was kostet das?” – per E-Mail und Telefon, jeden Tag aufs Neue. Jede Antwort kostet nur Minuten, aber zwanzig Mal am Tag ist das ein halber Arbeitstag.",
        testid: "problem-card-1",
    },
    {
        icon: FileStack,
        title: "Daten von Hand abtippen",
        text: "Angebote, Formulare, Anhänge: Daten wandern per Copy-Paste von einem System ins nächste, Dokumente werden gesucht, umbenannt, abgelegt. Fehleranfällig – und niemand im Team macht es gern.",
        testid: "problem-card-2",
    },
    {
        icon: CalendarClock,
        title: "Termin-Pingpong per E-Mail",
        text: "„Passt Ihnen Dienstag?” – „Nein, aber Donnerstag?” – fünf Mails für einen Termin. Währenddessen wartet der Kunde, und Ihr Kalender bleibt eine Baustelle.",
        testid: "problem-card-3",
    },
];

export const Problem = () => (
    <section id="problem" className="py-20 lg:py-28 border-t border-white/[0.06] scroll-mt-16" aria-labelledby="problem-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">Das Problem</p>
            <h2 id="problem-heading" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white max-w-2xl">
                Ihr Team arbeitet nicht langsam. Es erledigt nur zu viel von Hand.
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#9CA3AF] leading-relaxed max-w-2xl">
                Drei Zeitfresser, die fast jedes inhabergeführte Unternehmen kennt – egal ob Kanzlei,
                Hausverwaltung oder Handwerksbetrieb.
            </p>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                {ITEMS.map(({ icon: Icon, title, text, testid }) => (
                    <article
                        key={testid}
                        data-testid={testid}
                        className="rounded-2xl border border-white/[0.08] bg-[#161F30] p-6 sm:p-8 transition-colors duration-200 hover:border-emerald-500/40 hover:bg-[#1E293B]"
                    >
                        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20">
                            <Icon className="h-5 w-5 text-emerald-400" aria-hidden="true" />
                        </div>
                        <h3 className="mt-6 text-xl font-medium text-white leading-snug">{title}</h3>
                        <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{text}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
